import api from 'common/api'
import React, { FC, createContext, useContext, useEffect } from 'react'

const Context = () => {
  const getNavbarTitle = async () => {
    try {
      const title = await api.home.getNavbarTitle()
      localStorage.setItem('navbarTitle', JSON.stringify(title.data))
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    getNavbarTitle()
  }, [])
  return {
    state: {},
    actions: {}
  }
}

const AppContext = createContext<any>({ state: {}, actions: {} })

export const AppContextProvider: FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const value = Context()
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

export default function useAppContext() {
  return useContext<ReturnType<typeof Context>>(AppContext)
}
